import { isWownowApp } from './common'
import storage from '$common/utils/storage';

export const goLoginPage = () => {
  if (isWownowApp && window.WOWNOW && window.WOWNOW.navigationToRoute) {
    window?.WOWNOW?.navigationToRoute({
      route: 'SuperApp://SuperApp/login'
    })
  } else {
    if (process.env.NODE_ENV === 'development') {
      window.location.href = `/super/app/user/v1/index/login?callback=${encodeURIComponent(window.location.href)}`;
    } else {
      window.location.href = `/mobile-h5/super/app/user/v1/login?callback=${encodeURIComponent(window.location.href)}`;
    }
  }
}

const state = {
  hasLogin: false,
  userInfo: null
}

export const removeUserInfo = () => {
  state.userInfo = null
  state.hasLogin = false
  storage.remove('loginName')
  storage.remove('operatorNo')
}

export const getUserInfo = (goLogin = true) => {
  return new Promise((resolve, reject) => {
    if (isWownowApp) {
      if (!window.WOWNOW || !window.WOWNOW.getUserInfo) {
        console.log('window.WOWNOW.getUserInfo not exist!')
        storage.clear();
        reject()
        return
      }
      if (state.hasLogin) {
        resolve(state.userInfo)
      }
      window.WOWNOW.getUserInfo({
        success: res => {
          console.log('user info res is:', res)
          if (res && res.loginName) {
            state.hasLogin = true
            state.userInfo = res
            storage.setItem('loginName', res.loginName)
            storage.setItem('operatorNo', res.operatorNo)
            resolve(res)
          }
        },
        fail: res => {
          console.log('get user info fail')
          storage.clear();
          if (goLogin && window.WOWNOW && window.WOWNOW.navigationToRoute) {
            window.WOWNOW.navigationToRoute({
              route: 'SuperApp://SuperApp/login'
            });
          }
          reject('在wownow内还没有登录')
        },
        complete: () => {
          console.log('get user info complete')
        }
      })
    } else {
      const loginName = storage.getItem('loginName')
      const operatorNo = storage.getItem('operatorNo')
      if (loginName && operatorNo) {
        state.hasLogin = true
        state.userInfo = {
          loginName,
          operatorNo
        }
        resolve({
          loginName, operatorNo
        })
      } else {
        storage.clear();
        reject('在浏览器内还没有登录')
        if (goLogin) {
          goLoginPage()
        }
      }
    }
  })
}

// 从后3位数字往前的4个数字隐藏处理
export const hideUserPhone = (phone) => {
  if (!phone) {
    return phone
  }

  phone = phone + ''

  const len = phone.length
  const endStart = len - 3
  const startEnd = len - 3 - 4

  const start = phone.substr(0, startEnd)
  const end = phone.substr(endStart)
  return start + '****' + end
}
